import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, BarChart3, TrendingUp, Lock, ArrowRight } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { technology } from '../data/mock';
import '../styles/pages.css';
import { soemLogo } from '../assets';
import usePageMeta from '../hooks/usePageMeta';

const iconMap = {
  1: Monitor,
  2: BarChart3,
  3: TrendingUp,
  4: Lock
};

const Technology = () => {
  usePageMeta({
    title: 'Tecnología',
    description: 'Plataforma propia y aplicación móvil para levantar evaluaciones en sitio, incluso sin conexión, con evidencia y trazabilidad completa.',
    path: '/technology',
  });

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Tecnología y Evolución</h1>
          <p>Herramientas modernas al servicio del criterio profesional</p>
        </div>
      </section>

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="intro-content">
            <p className="lead-text">{technology.intro}</p>
          </div>
        </div>
      </section>

      {/* Technology Areas */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Áreas de Aplicación</h2>
          </div>
          <div className="tech-grid">
            {technology.areas.map((area) => {
              const IconComponent = iconMap[area.id];
              return (
                <div key={area.id} className="tech-card">
                  <div className="tech-icon">
                    {IconComponent && <IconComponent size={28} />}
                  </div>
                  <h3>{area.title}</h3>
                  <p>{area.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="section">
        <div className="container">
          <div className="disclaimer-box">
            <h3>El factor humano</h3>
            <p>{technology.disclaimer}</p>
          </div>
        </div>
      </section>

      {/* Evolution */}
      <section className="section section-alt">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Mejora Continua</h2>
              <p>
                La tecnología nos permite recopilar datos valiosos de cada evento, 
                identificar patrones y tendencias, y aplicar lecciones aprendidas 
                en proyectos futuros.
              </p>
              <p>
                Este enfoque de mejora continua garantiza que nuestras metodologías 
                evolucionen constantemente, incorporando las mejores prácticas y 
                adaptándose a los nuevos desafíos del entorno.
              </p>
              <p>
                Sin embargo, siempre mantenemos el principio de que la tecnología 
                es una herramienta, no un sustituto del juicio profesional y la 
                experiencia acumulada.
              </p>
            </div>
            <div className="content-image">
              <div className="image-box">
                <img 
                  src={soemLogo} 
                  alt="SOEM Partners Group"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Tecnología con propósito</h2>
            <p>
              Conozca cómo aplicamos tecnología de manera estratégica 
              para potenciar la seguridad de su evento.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Solicitar información
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Technology;
